<template>
  <div>
    <div v-if="user" class="loader-container">
      <div class="loading-wrapper">
        <v-progress-linear
          value="3"
          height="3"
          indeterminate
          color="black"
        ></v-progress-linear>
      </div>
    </div>
    <div v-if="user == false">
      <Navbar />
      <div class="login-container">
        <div class="page-wrapper">
          <div class="welcome-text">Welcome back,</div>
          <div class="grey-text">Kindly fill in your details</div>
          <LoginForm
            v-bind="{ form, handleLogin, form_errors, spinner, handleRegister }"
          />
        </div>
      </div>
    </div>
    <AlertSuccess v-if="successMsg" time="7" />
    <AlertError v-if="errorMsg" time="7" />
  </div>
</template>

<script>
import Axios from "axios";
import countryFinder from "country-finder";
import { mapActions, mapState } from "vuex";
import { getDev, fetchClientProjects } from "@/api";
import Navbar from "@/components/Navbar/onboarding_navbar";
import LoginForm from "./login_form";
import AlertSuccess from "@/components/alertSuccess";
import { logoutUser } from "@/utils/logoutUser";
export default {
  props: {},
  components: {
    Navbar,
    LoginForm,
    AlertSuccess,
  },
  data: () => ({
    form: {
      email: "",
      password: "",
    },
    form_errors: {
      email: [],
      main: "",
    },
    spinner: false,
    user: true,
  }),
  created() {
    this.checkUserAccess();
  },
  methods: {
    ...mapActions("devDashboard", ["setTeamDetails"]),
    ...mapActions("clientDashboard", ["setAllProjects"]),
    ...mapActions("userManagement", ["setAutheticatedUser", "logOutUser"]),
    handleLogin(event) {
      event.preventDefault();
      this.form_errors = {
        name: [],
        email: [],
        main: "",
      };
      if (!this.form.email) {
        this.$developConsole(this.form.email, "Email");
        this.form_errors.main = "Email required to login";
      } else if (!this.form.password) {
        this.form_errors.main = "Password?";
      } else if (this.form.password.length < 6) {
        this.form_errors.main = "Invalid password";
      } else {
        this.handleSubmitForm(this.form);
      }
    },
    handleSubmitForm(form) {
      this.spinner = true;
      Axios.post(this.$baseUrl + "/auth/login", form)
        .then((r) => {
          this.$developConsole(r, "response");
          var response = r.data;
          if (response.msg == "errors") {
            this.spinner = false;
            if (response.data.email) {
              this.form_errors.main = response.data.email[0];
            } else if (response.data.error) {
              this.form_errors.main = response.data.error;
            }
          } else if (response.status == 1) {
            this.$Mixpanel.track("LoginAttempt", {
              distinct_id: this.form.email,
            });
            this.setLogInUser(response.data);
            if (
              response.data.user_type === 2 ||
              response.data.user_type === 5
            ) {
              this.getMyProject();
            }
            if (
              response.data.user_type === 1 ||
              response.data.user_type === 6
            ) {
              this.getTeamDetails();
            }
          }
        })
        .catch((error) => {
          this.$developConsole(error, "Login error");
          this.spinner = false;
          if (error.response.data.error == "Invalid login! Please try again") {
            this.form_errors.main = "Invalid Email Address/Password";
          } else if (error.response.data.status == 0) {
            this.form_errors.main = error.response.data.errors.email[0];
          }
        });
    },
    checkUserAccess() {
      if (localStorage.hasOwnProperty("grupa_user")) {
        const user = JSON.parse(localStorage.getItem("grupa_user"));
        if (user.user_type == 1 || user.user_type == 6) {
          this.getTeamDetails();
        } else if (user.user_type == 2 || user.user_type == 5) {
          this.getMyProject();
        }
      } else {
        this.user = false;
      }
    },
    handleRegister() {
      this.$router.push({ name: "signup" });
    },
    setLogInUser(user) {
      let payload = {
        user,
        isAuthenticated: true,
        userType: user.user_type,
      };
      this.setAutheticatedUser(payload);
      localStorage.setItem("grupa_user", JSON.stringify(user));
    },
    getMyProject() {
      fetchClientProjects()
        .then((response) => {
          if (response.data.status === 1) {
            let projects = response.data.data.projects;
            if (projects.length > 0) {
              let lastProject = projects[projects.length - 1];
              this.setAllProjects(response.data.data.projects);
              this.spinner = false;
              this.$router.push({
                name: "project_workspace",
                params: { id: lastProject.id },
              });
            } else {
              this.$router.push({ name: "start_project" });
            }
          }
        })
        .catch((error) => {
          if (!error.response) {
            this.logOutUser();
            window.location.reload();
          }
        });
    },
    getTeamDetails() {
      let data = null;
      getDev()
        .then((res) => {
          if (res.data.status == 1) {
            this.spinner = false;
            this.setTeamDetails(res.data);
            this.$developConsole(res.data, "login data here");
            data = res.data.data;
            if (data.team.activation_level == 0) {
              // this route does not exist and errors out
              // this.$router.push({ name: "create_team" });
              this.$router.push({ name: "dev_dashboard" });
            } else if (data.team.activation_level == 1) {
              this.$router.push({ name: "invite_team" });
            } else if (
              data.team.activation_level == 2 &&
              data.user.activation_level == 1
            ) {
              this.$router.push({ name: "tools_lang" });
            } else {
              this.$router.push({ name: "dev_dashboard" });
            }
          }
        })
        .catch((err) => {
          this.spinner = false;
          this.logOutUser();
          window.location.reload();
        });
    },
  },
  computed: {
    ...mapState("userManagement", ["currentUser"]),
    ...mapState("alertMsg", ["successMsg", "errorMsg"]),
  },
  watch: {
    currentUser: function (newVal) {},
  },
};
</script>
  
<style scoped>
* {
  font-family: Moderat;
  font-style: normal;
  font-weight: normal;
}
.loader-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.page-wrapper {
  width: 410px;
  text-align: left;
}
.welcome-text {
  margin-top: 74px;
  font-size: 23px;
  line-height: 28px;
  color: #1b1e22;
}
.grey-text {
  margin-top: 8px;
  font-size: 16px;
  line-height: 130%;
  color: #979da5;
}
.loading-wrapper {
  width: 400px;
}
</style>